<p-card styleClass="flex w-full h-full p-4">
  <ng-template pTemplate="header">
    <h2>Renewal Progress</h2>
  </ng-template>
  <div class="content max-h-[340px] overflow-y-auto pr-4">
    <div *ngIf="loading" class="loading">
      Loading renewal data...
    </div>
    <div *ngIf="error" class="error">
      {{ error }}
    </div>
    <div *ngIf="!loading && !error" class="flex flex-wrap justify-center md:justify-between gap-3 w-full">
      <!-- Overall Progress -->
      <div *ngIf="overallData" class="location-item bg-white dark:bg-surface-900 shadow-sm hover:shadow-md dark:shadow-surface-50 w-full sm:w-1/2 md:w-8/25 h-full justify-center items-center">
        <div class="renewal-header text-center">
          <h5 class="location-name">Overall</h5>
        </div>
        <div class="renewal-details text-center">
          <div class="goal">Goal: 50%</div>
          <div class="count">Current: ({{ overallData.data.renewedCount | number }}/{{ overallData.data.tripCount | number }})</div>
        </div>
        <p-knob 
          styleClass="flex justify-center items-center"
          [(ngModel)]="overallData.displayPercentage" 
          [readonly]="true"
          [strokeWidth]="10"
          [size]="100"
          [textColor]="getKnobColor(overallData.percentage)"
          [valueColor]="getKnobColor(overallData.percentage)"
          [valueTemplate]="overallData.percentage.toString() + '%'"
        ></p-knob>
      </div>

      <!-- Location Progress -->
      <div *ngFor="let item of locationData" class="location-item bg-white dark:bg-surface-900 shadow-sm hover:shadow-md dark:shadow-surface-50 w-full sm:w-1/2 md:w-8/25 justify-center items-center">
        <div class="renewal-header text-center">
          <h5 class="location-name">{{ item.data.pastDestination }}</h5>
        </div>
        <div class="renewal-details text-center">
          <div class="goal">Goal: 50%</div>
          <div class="count">Current: ({{ item.data.renewedCount | number }}/{{ item.data.tripCount | number }})</div>
        </div>
        <p-knob 
          styleClass="flex justify-center items-center"
          [(ngModel)]="item.displayPercentage" 
          [readonly]="true"
          [strokeWidth]="10"
          [size]="100"
          [textColor]="getKnobColor(item.percentage)"
          [valueColor]="getKnobColor(item.percentage)"
          [valueTemplate]="item.percentage.toString() + '%'"
        ></p-knob>
      </div>
    </div>
  </div>
</p-card> 